import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { SampleService } from '../../../core/http/sample.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';

@Component({
  selector: 'app-send-review',
  templateUrl: './send-review.component.html',
  styleUrls: ['./send-review.component.scss'],
})
export class SendReviewComponent implements OnInit {
  @Input() data;

  isLoading = false;
  Errors = null;
  socs = null;
  mode = null;
  selectedDr;
  Success = null;
  return;
  drs: any = [];

  stateForm = new FormGroup({
    LocalResultId: new FormControl(''),
    FinalizerEmail: new FormControl(''),
    FinalizerName: new FormControl(''),
    Title: new FormControl(''),
    MessageBody: new FormControl(''),
  });

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public sample: SampleService,
    private location: Location
  ) {}

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const { LocalResultId, FinalizerEmail, FinalizerName, Title, MessageBody } =
      this.stateForm.value;
    this.sample
      .pushForReview(
        LocalResultId,
        FinalizerEmail,
        FinalizerName,
        Title,
        MessageBody
      )
      .subscribe(
        (resSuccess) => {
          this.return = resSuccess;
          this.isLoading = false;
          console.log(resSuccess);

          if (this.return.success) {
            this.closeModal();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            window.location.reload();
          } else {
            console.log(this.return);
            this._snackBar.open(this.return.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isLoading = false;
          this._snackBar.open('Error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }
  closeModal() {
    this.modal.closeModal();
  }

  slectOnChange(event: any) {
    let email;
    let id;
    let dr = this.drs.filter((t) => t.name == event.value);
    this.stateForm.patchValue({
      FinalizerEmail: dr[0].email_no,
      FinalizerName: dr[0].name,
    });
    console.log(dr);
  }

  ngOnInit(): void {
    console.log(this.data.resultId, this.data.body);
    this.stateForm.patchValue({
      LocalResultId: this.data.resultId,
      MessageBody: this.data.body,
    });
    console.log(this.stateForm.value);

    this.sample.getdr().subscribe(
      (resSuccess) => {
        this.drs = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
}
